"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var abort_controller_1 = require("abort-controller");
require("abort-controller/polyfill");
require("isomorphic-fetch");
var ConversationCreatedEvent_1 = require("./model/events/ConversationCreatedEvent");
var DashboardViewedEvent_1 = require("./model/events/DashboardViewedEvent");
var ExchangeFinalizedEvent_1 = require("./model/events/ExchangeFinalizedEvent");
var HomeCreatedEvent_1 = require("./model/events/HomeCreatedEvent");
var HomeDetailViewedEvent_1 = require("./model/events/HomeDetailViewedEvent");
var HomesSearchedEvent_1 = require("./model/events/HomesSearchedEvent");
var HomeSearchResultsViewedEvent_1 = require("./model/events/HomeSearchResultsViewedEvent");
var PageViewedEvent_1 = require("./model/events/PageViewedEvent");
var UserCreatedEvent_1 = require("./model/events/UserCreatedEvent");
var ExperimentAssignedEvent_1 = require("./model/events/ExperimentAssignedEvent");
var CreationResponsePromise = Promise;
var ClientOptions = (function () {
    function ClientOptions() {
        this.timeout = 2e3;
        this.endpoint = "";
    }
    return ClientOptions;
}());
exports.ClientOptions = ClientOptions;
var EventsApiClient = (function () {
    function EventsApiClient(authorizationTokenProviderFn, options) {
        this.attempts = 0;
        this.maxBackoffDelay = 20e3;
        this.maxRetries = 10;
        this.options = new ClientOptions();
        if (typeof authorizationTokenProviderFn === "undefined") {
            throw new Error("Authorization token provider not defined");
        }
        this.options = Object.assign(this.options, options);
        this.authorizationTokenProvider = authorizationTokenProviderFn;
    }
    EventsApiClient.prototype.conversationCreated = function (conversationId) {
        return this.createEvent(new ConversationCreatedEvent_1.ConversationCreatedEvent(conversationId));
    };
    EventsApiClient.prototype.dashboardViewed = function (homeIds) {
        return this.createEvent(new DashboardViewedEvent_1.DashboardViewedEvent(homeIds));
    };
    EventsApiClient.prototype.exchangeFinalized = function (exchangeId) {
        return this.createEvent(new ExchangeFinalizedEvent_1.ExchangeFinalizedEvent(exchangeId));
    };
    EventsApiClient.prototype.experimentAssigned = function (experimentId, variantId) {
        return this.createEvent(new ExperimentAssignedEvent_1.ExperimentAssignedEvent(experimentId, variantId), false);
    };
    EventsApiClient.prototype.homeCreated = function (homeId) {
        return this.createEvent(new HomeCreatedEvent_1.HomeCreatedEvent(homeId));
    };
    EventsApiClient.prototype.homeDetailViewed = function (homeId) {
        return this.createEvent(new HomeDetailViewedEvent_1.HomeDetailViewedEvent(homeId));
    };
    EventsApiClient.prototype.homesSearched = function (id, query) {
        return this.createEvent(new HomesSearchedEvent_1.HomesSearchedEvent(id, query), false);
    };
    EventsApiClient.prototype.homeSearchResultsViewed = function (homeIds, queryId) {
        return this.createEvent(new HomeSearchResultsViewedEvent_1.HomeSearchResultsViewedEvent(homeIds, queryId));
    };
    EventsApiClient.prototype.pageViewed = function () {
        return this.createEvent(new PageViewedEvent_1.PageViewedEvent(), false);
    };
    EventsApiClient.prototype.userCreated = function () {
        return this.createEvent(new UserCreatedEvent_1.UserCreatedEvent());
    };
    EventsApiClient.prototype.checkStatus = function (response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    };
    EventsApiClient.prototype.computeRetryDelay = function (attempt) {
        var temp = Math.min(this.maxBackoffDelay, 20 * Math.pow(2, attempt));
        var min = 0;
        var max = temp / 2;
        return temp / 2 + Math.floor(Math.random() * (max - min + 1) + min);
    };
    EventsApiClient.prototype.createEvent = function (event, authenticationRequired) {
        var _this = this;
        if (authenticationRequired === void 0) { authenticationRequired = true; }
        return this.authorizationTokenProvider()
            .then(function (token) {
            if (!token && authenticationRequired) {
                throw new Error("Cannot create authentified event without Authorization token");
            }
            else {
                if (_this.clockCorrection === undefined) {
                    return _this.syncClock().then(function () { return _this.sendEvent(event, token); });
                }
                else {
                    return _this.sendEvent(event, token);
                }
            }
        });
    };
    EventsApiClient.prototype.sendEvent = function (event, token) {
        if (token === void 0) { token = null; }
        return __awaiter(this, void 0, CreationResponsePromise, function () {
            var url, sender;
            return __generator(this, function (_a) {
                url = this.options.endpoint + "/api/events/" + event.getType();
                if (this.clockCorrection) {
                    event.correctTimestamp(this.clockCorrection);
                }
                sender = ("sendBeacon" in navigator) ? this.createEventWithSendBeaconAndFallback : this.createEventWithFetch;
                return [2, sender.call(this, url, event, token)];
            });
        });
    };
    EventsApiClient.prototype.createEventWithSendBeaconAndFallback = function (url, event, token) {
        var _this = this;
        return this.createEventWithSendBeacon(url, event, token)
            .catch(function () { return _this.createEventWithFetch(url, event, token); });
    };
    EventsApiClient.prototype.createEventWithSendBeacon = function (url, event, token) {
        return __awaiter(this, void 0, CreationResponsePromise, function () {
            var data;
            return __generator(this, function (_a) {
                if (token) {
                    event.authorization_token = token;
                }
                data = new Blob([JSON.stringify(event)], { type: "application/json" });
                return [2, navigator.sendBeacon(url, data) ? Promise.resolve() : Promise.reject(new Error("createEventWithSendBeacon failed"))];
            });
        });
    };
    EventsApiClient.prototype.isBrowserContext = function () { return (typeof window !== "undefined"); };
    EventsApiClient.prototype.buildHeaders = function (token) {
        var headers = {
            "Content-Type": "application/json"
        };
        if (token) {
            headers.Authorization = "Bearer " + token;
        }
        if (!this.isBrowserContext()) {
            headers["User-Agent"] = "events-api-debug";
        }
        if (this.options.headers) {
            Object.assign(headers, this.options.headers);
        }
        return headers;
    };
    EventsApiClient.prototype.createEventWithFetch = function (url, event, token) {
        return __awaiter(this, void 0, CreationResponsePromise, function () {
            return __generator(this, function (_a) {
                return [2, this.fetch(url, {
                        method: "POST",
                        body: JSON.stringify(event),
                        headers: this.buildHeaders(token),
                        credentials: "same-origin",
                        mode: "same-origin",
                        cache: "no-store"
                    })];
            });
        });
    };
    EventsApiClient.prototype.fetch = function (url, requestOptions) {
        return __awaiter(this, void 0, CreationResponsePromise, function () {
            var controller, signal, handleFetchError;
            var _this = this;
            return __generator(this, function (_a) {
                controller = new abort_controller_1.default();
                signal = controller.signal;
                setTimeout(function () { return controller.abort(); }, this.options.timeout);
                handleFetchError = function (e) {
                    if (e.response !== undefined) {
                        var isRetryable = _this.isRetryableRequest(e.response);
                        if (isRetryable) {
                            if (e.name !== "AbortError" && isRetryable && _this.attempts < _this.maxRetries) {
                                _this.attempts += 1;
                                return _this.retryWithDelay(function () { return _this.fetch(url, requestOptions); }, _this.computeRetryDelay(_this.attempts));
                            }
                        }
                    }
                    _this.resetAttempts();
                    throw e;
                };
                return [2, fetch(url, __assign(__assign({}, requestOptions), { keepalive: true, signal: signal }))
                        .then(this.checkStatus)
                        .catch(handleFetchError)];
            });
        });
    };
    EventsApiClient.prototype.resetAttempts = function () {
        this.attempts = 0;
    };
    EventsApiClient.prototype.isRetryableRequest = function (response) {
        return ([429, 500, 503, 504].indexOf(response.status) !== -1);
    };
    EventsApiClient.prototype.syncClock = function () {
        return __awaiter(this, void 0, CreationResponsePromise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, this.fetch(this.options.endpoint + "/api/events/ping", { method: "POST" })
                        .then(function (r) { return _this.correctClockSkew(r); })];
            });
        });
    };
    EventsApiClient.prototype.correctClockSkew = function (response) {
        var responseDate = response.headers.get("Date");
        if (responseDate) {
            this.clockCorrection = new Date(responseDate).getTime() - new Date().getTime();
        }
    };
    EventsApiClient.prototype.retryWithDelay = function (fn, delay) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve) { return setTimeout(resolve, delay); })
                        .then(fn)];
            });
        });
    };
    return EventsApiClient;
}());
exports.EventsApiClient = EventsApiClient;
//# sourceMappingURL=EventsApiClient.js.map